import type { ImgHTMLAttributes } from "react";
import { cn } from "@/lib/utils";
import master from "@/assets/brand/buildease-logo-master.png";

// Canonical BuildEase brand asset: the full locked lockup (symbol + wordmark + tagline).
// Scale proportionally via `height` (px) or responsive `h-*` classes. Never crop, recolour, or recreate.
interface BuildEaseLogoProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "alt" | "height"> {
  height?: number;
  muted?: boolean;
}

export function BuildEaseLogo({ height, muted = false, className, style, ...props }: BuildEaseLogoProps) {
  return (
    <img
      data-testid="buildease-logo"
      src={master}
      alt="BuildEase — Simplify. Build. Live."
      draggable={false}
      className={cn("block w-auto max-w-full shrink-0 self-start object-contain select-none", muted && "opacity-60 grayscale", className)}
      style={height ? { height, ...style } : style}
      {...props}
    />
  );
}
